import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['TUI-switch', __props.value ? 'TUI-switch-checked' : 'TUI-switch-no-checked'])
      }, null, 2);
    };
  }
});